var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-select',{attrs:{"items":_setup.items,"item-text":_setup.formatDate,"label":"振替日","no-data-text":"選択できる公休日がありません。","return-object":"","rules":[_setup.InputRules.required]},model:{value:(_setup.modelValue),callback:function ($$v) {_setup.modelValue=$$v},expression:"modelValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }